import type React from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { SignatureStatsActiveContainer } from './SignatureStatsActiveContainer';
import { SignatureStatsClosedContainer } from './SignatureStatsClosed';

const SignatureStatsContainerInner: React.FC = () => {
	const { data: { petition: { status } } } = usePetitionDetailsPageData();

	if (status === 'CLOSED') {
		return <SignatureStatsClosedContainer />;
	}

	if (status === 'VICTORY') {
		return null;
	}

	return <SignatureStatsActiveContainer />;
};

export const SignatureStatsMobileContainer: React.FC = () => {
	return (
		<div className="my-4" data-qa="signature-stats-section">
			<SignatureStatsContainerInner />
		</div>
	);
};
